import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfigRoutingModule } from './config-routing.module';
import { UsuariosComponent } from './components/usuarios/usuarios.component';
import { UsuariosRolesComponent } from './components/usuarios/usuarios-roles/usuarios-roles.component';
import { EndpointsComponent } from './components/endpoints/endpoints.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { PropertiesComponent } from './components/properties/properties.component';


@NgModule({
  declarations: [
    UsuariosComponent,
    UsuariosRolesComponent,
    EndpointsComponent,
    PropertiesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ConfigRoutingModule,
    ImportsModule,
  ]
})
export class ConfigModule { }
